import { render, staticRenderFns } from "./Dreams.vue?vue&type=template&id=297e3a0e"
import script from "./Dreams.vue?vue&type=script&lang=js"
export * from "./Dreams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports